const darkReducer = (state, action) => {
    switch (action.type) {
        case 'LIGHT': {
            localStorage.setItem('darkMode', JSON.stringify(false));

            return {
                darkMode: false,
            };
        }

        case 'DARK': {
            localStorage.setItem('darkMode', JSON.stringify(true));

            return {
                darkMode: true,
            };
        }

        case 'TOGGLE': {
            const newDarkMode = !state.darkMode;

            localStorage.setItem('darkMode', JSON.stringify(newDarkMode));

            return {
                darkMode: newDarkMode,
            };
        }

        default:
            return state;
    }
};

export default darkReducer;
